import {
  getDatabase,
  ref,
  set,
  update,
  push,
  onValue,
  get,
  remove,
  serverTimestamp
} from 'firebase/database';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import {db} from '../../../../firebase'
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';

export const subscribeToActiveSession = (courseId, callback) => {
  const database = getDatabase();
  const sessionsRef = ref(database, `sessions/${courseId}`);
  return onValue(sessionsRef, (snapshot) => {
    callback(snapshot.val());
  });
};

export const subscribeToPollState = (courseId, sessionId, callback) => {
  const database = getDatabase();
  const pollStateRef = ref(database, `sessions/${courseId}/${sessionId}/pollState`);
  return onValue(pollStateRef, (snapshot) => {
    callback(snapshot.val());
  });
};

export const subscribeToAttendance = (classId, sessionId, callback) => {
  const database = getDatabase();
  const attendanceRef = ref(database, `attendance/${classId}/${sessionId}/userIds`);
  return onValue(attendanceRef, (snapshot) => {
    callback(snapshot.val());
  });
};

export const subscribeToAnswers = (courseId, sessionId, questionNumber, callback) => {
  const database = getDatabase();
  const answersRef = ref(database, `answers/${courseId}/${sessionId}/${questionNumber}`);
  return onValue(answersRef, (snapshot) => {
    callback(snapshot.val());
  });
};

export const createSession = async (courseId) => {
  const database = getDatabase();
  const sessionRef = push(ref(database, `sessions/${courseId}`));
  const newSessionId = sessionRef.key;
  await set(sessionRef, {
    start_date_time: serverTimestamp(),
    total_questions: 0,
    questions: {},
  });
  // Initialize poll state
  await set(ref(database, `sessions/${courseId}/${newSessionId}/pollState`), {
    isPollActive: false,
    questionNumber: 1,
    questionType: 'multiple_choice',
    pollStartTime: null,
  });
  return newSessionId;
};

export const endSessionInFirebase = async (courseId, sessionId) => {
  const database = getDatabase();
  const sessionRef = ref(database, `sessions/${courseId}/${sessionId}`);

  // fetch the session data once
  const snapshot = await get(sessionRef);
  const sessionData = snapshot.val() || {};

  // if no questions, delete the session
  if (!sessionData.questions || Object.keys(sessionData.questions).length === 0) {
    await remove(sessionRef);
    return;
  }

  // otherwise mark the end time
  await update(sessionRef, { end_date_time: serverTimestamp() });

  // check if AI reporting is enabled for this class
  // const classSnap = await getDoc(doc(db, 'classes', courseId));
  // if (classSnap.exists() && classSnap.data().aiReporting === true) {
  //   // kick off AI report generation (fire-and-forget)
  //   const FUNCTION_URL = window.location.hostname === "localhost"
  //   ? `http://localhost:5001/coursengage-test/us-central1/generateAIReport`
  //   : "https://us-central1-coursengage-test.cloudfunctions.net/generateAIReport";
  //   try {
  //   // Just trigger, don't await!
  //   fetch(FUNCTION_URL, {
  //     method: 'POST',
  //     headers: { 'Content-Type': 'application/json' },
  //     body: JSON.stringify({ courseId, sessionId }),
  //     keepalive: true
  //   }).catch(err => {
  //     // Optional: log error, don't block anything
  //     console.error('Failed to start AI report generation:', err);
  //   });
  //   // No await! Don't block the rest of the function.
  //   console.log('AI report generation triggered (fire-and-forget).');
  // } catch (err) {
  //     console.error('Failed to start AI report generation:', err);
  //     //alert('Failed to start AI report generation: ' + err.message);
  //   }
  // } else {
  //   console.log(
  //     `Skipping AI report for ${courseId} because aiReporting is not enabled.`
  //   );
  // }
};


export const addQuestionToSession = async (courseId, sessionId, questionNumber, questionType, photoUrl = 'InClass', optionsCount = 5) => {
  const database = getDatabase();
  const questionRef = ref(database, `sessions/${courseId}/${sessionId}/questions/${questionNumber}`);
  await set(questionRef, {
    question_type: questionType,
    question_photo: photoUrl,
    question_number: questionNumber,
    pool: 'on',
    options_count: optionsCount,
  });
};

export const updatePollStateInFirebase = async (courseId, sessionId, pollState) => {
  const database = getDatabase();
  const pollStateRef = ref(database, `sessions/${courseId}/${sessionId}/pollState`);
  await update(pollStateRef, pollState);
};

export const updateCorrectAnswerInFirebase = async (courseId, sessionId, questionNumber, correctAnswer, questionType) => {
  const database = getDatabase();
  const answerRef = ref(database, `sessions/${courseId}/${sessionId}/questions/${questionNumber}`);
  await update(answerRef, {
    correct_answer:
      (questionType === 'multiple_choice' || questionType === 'multiple_multiple_choice' || questionType === "short_input")
        ? correctAnswer
        : correctAnswer[0],
  });
};